import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * Updates product variant title elements when variant selection changes.
 * Listens for VariantUpdateEvent and updates [data-product-variant-title] spans.
 */
function updateVariantTitle(event) {
  if (!(event instanceof VariantUpdateEvent)) return;

  const { resource: variant, data } = event.detail;
  const productId = data?.productId;

  if (!variant || !productId) return;

  const variantTitle = variant.title || '';

  document
    .querySelectorAll(`[data-product-variant-title][data-product-id="${productId}"]`)
    .forEach((el) => {
      el.textContent = variantTitle;
    });
}

document.addEventListener(ThemeEvents.variantUpdate, updateVariantTitle);
